export const validationsEs = {
  required: 'Este campo es obligatorio',
  email: 'Este campo debe ser un email válido',
  min_value: 'El valor mínimo para este campo es {min}',
  max_value: 'El valor máximo para este campo es {max}',
  ip: 'No parece una ip',
  host: 'No parece una url',
  phone: 'No es un teléfono válido',
  numeric: 'Este campo debe tener un valor numérico entero',
  float: {
    hint: 'Ejemplo: 12.3',
    hint_min: 'El valor mínimo es {min}.',
    hint_max: 'El valor máximo es {max}.',
    hint_decimals: 'El número máximo de decimales es {decimals}.',
  },
  categoryPercentage:'La suma de los campos porcentaje de todos los niveles no suma 100, asegúrate que la suma de todos los porcentajes da como resultado 100'
};
